<div class="filter-more-item" *ngIf="mobile">
  <label class="upper-label"
    >Property type
    <span *ngIf="checkedCount > 0">({{ checkedCount }})</span></label
  >
  <ul>
    <li class="toggler">
      <mat-checkbox
        class="example-margin"
        color="primary"
        [checked]="allSelected"
        (change)="toggleAllSelection()"
        >{{ allSelected ? 'Deselect' : 'Select' }} all</mat-checkbox
      >
    </li>
    <div class="divider"></div>
    <div class="grid grid-cols-2">
      <ng-container *ngFor="let propertyType of propertyTypes">
        <li *ngFor="let subtype of propertyType.subtypes">
          <mat-checkbox
            class="example-margin"
            color="primary"
            [(ngModel)]="checkedSubtypes[subtype]"
            (ngModelChange)="onChangeSubtypes()"
            [value]="subtype"
          >
            {{ subtype | stringTransform: 'capitalizeFirstLetter' }}
          </mat-checkbox>
        </li>
      </ng-container>
    </div>
  </ul>
</div>

<ng-container *ngIf="!mobile">
  <div
    class="filter-item"
    [matMenuTriggerFor]="propertyTypeFilter"
    #trigger="matMenuTrigger"
    [ngClass]="{ active: checkedCount > 0 || isOpen }"
    (menuOpened)="isOpen = true"
    (menuClosed)="isOpen = false"
  >
    <span>
      Property type
      <span class="hidden lg:inline" *ngIf="checkedCount > 0"
        >({{ checkedCount }})</span
      >
    </span>
    <app-shared-icon name="chevron-down-2"></app-shared-icon>
  </div>

  <mat-menu
    #propertyTypeFilter="matMenu"
    xPosition="after"
    class="filters-mat-menu"
  >
    <div
      class="filter-dropdown filter-dropdown--property-type"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <ul>
        <li class="toggler">
          <mat-checkbox
            labelPosition="before"
            class="example-margin"
            color="primary"
            [checked]="allSelected"
            (change)="toggleAllSelection()"
            >{{ allSelected ? 'Deselect' : 'Select' }} all</mat-checkbox
          >
        </li>
        <li *ngFor="let propertyType of propertyTypes" class="parent">
          <span class="type-label">{{ propertyType.key }}</span>
          <ul>
            <li *ngFor="let subtype of propertyType.subtypes">
              <mat-checkbox
                labelPosition="before"
                class="example-margin"
                color="primary"
                [(ngModel)]="checkedSubtypes[subtype]"
                (ngModelChange)="onChangeSubtypes()"
                [value]="subtype"
              >
                {{ subtype | stringTransform: 'capitalizeFirstLetter' }}
              </mat-checkbox>
            </li>
          </ul>
        </li>
      </ul>

      <app-filter-v2-buttons
        *ngIf="!mobile"
        (resetAction)="resetSubtypes()"
        (applyAction)="closeMenu()"
      ></app-filter-v2-buttons>
    </div>
  </mat-menu>
</ng-container>
